import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AdminPage from "@/pages/AdminPage";
import { lenisRef, scrollToId } from "@/components/landing/scroll";
import { PeopleStrip } from "@/components/landing/PeopleStrip";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Services } from "@/components/landing/Services";
import { RoadTrips } from "@/components/landing/RoadTrips";
import { FozCombo } from "@/components/landing/FozCombo";
import { SpecialTrips } from "@/components/landing/SpecialTrips";
import { Destinations } from "@/components/landing/Destinations";
import { Steps } from "@/components/landing/Steps";
import { Pricing } from "@/components/landing/Pricing";
import { Testimonials } from "@/components/landing/Testimonials";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";

function Landing() {
  const [prefill, setPrefill] = useState(null);
  const pickDestino = (destino) => setPrefill({ destino, n: Date.now() });
  const pickPlan = (plan, transporte) => {
    setPrefill(transporte ? { plan, transporte, n: Date.now() } : { plan, n: Date.now() });
    scrollToId("contacto");
  };

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    lenisRef.current = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); lenisRef.current = null; };
  }, []);

  return (
    <div className="overflow-x-clip">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <RoadTrips />
        <FozCombo />
        <SpecialTrips />
        <Destinations onPick={pickDestino} />
        <Steps />
        <Pricing onPick={pickPlan} />
        <Testimonials />
        <PeopleStrip />
        <Contact prefill={prefill} />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<Landing />} />
      </Routes>
      <Toaster position="bottom-center" richColors />
    </BrowserRouter>
  );
}

export default App;
